module.exports = "/images/label_fully_booked.png?2039fe25c22687de2761391e2d85a223";